import React, { useState, useEffect } from 'react'

import { Header, PageWithTitle, CenteredContent } from '../styles/Containers'
import { PageTitle } from '../styles/Text'
import axios from '../../dataClient/dataClient'
import Loading from '../common/Loading'
import LoadingError from '../common/LoadingError'
import FilteredFOIs from '../foiDashboard/FilteredFOIs'
import { formatFoiDates } from '../../util/foiFormatting'

function FOIDashboardPage({ isCompleted = false }) {
  const [foiList, setFoiList] = useState([])

  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState()

  const [users, setUsers] = useState()
  const [loadingUsers, setLoadingUsers] = useState(!isCompleted)
  const [usersError, setUsersError] = useState(false)

  function getUsers() {
    axios
      .get(`/users`)
      .then(({ data }) => setUsers(data.data))
      .catch(e => {
        console.error('Failed to retrieve users', e)
        setUsersError(true)
      })
      .finally(() => setLoadingUsers(false))
  }

  useEffect(() => {
    if (!isCompleted) getUsers()

    axios
      .get(`/foi?type=${isCompleted ? 'completed' : 'in-progress'}`)
      .then(({ data }) => {
        setFoiList(
          data.data.map(foi => {
            return formatFoiDates(foi)
          })
        )
        setIsLoading(false)
      })
      .catch(e => {
        console.error(`Failed retrieving ${isCompleted ? 'completed' : 'in progress'} FOIs`, e)
        setError(true)
        setIsLoading(false)
      })
  }, [])

  if (isLoading || loadingUsers) return <Loading />

  if (error || usersError)
    return <LoadingError message={["We're sorry.", 'There was an error loading your FOIs.', 'Please refresh the page to try again.']} />

  return (
    <PageWithTitle gap="15px">
      <Header>
        <PageTitle>FOIs - {isCompleted ? 'Completed' : 'In Progress'}</PageTitle>
      </Header>
      <CenteredContent>
        <FilteredFOIs foiList={foiList} isCompleted={isCompleted} users={users} />
      </CenteredContent>
    </PageWithTitle>
  )
}

export default FOIDashboardPage
